/**
 * 設定ボタンコンポーネント
 * 
 * 歯車アイコンをクリックすると設定パネルを開く。
 * SettingsPanelと組み合わせて使用。
 */
import { useState, useRef, useCallback } from 'react';
import { useLanguage } from '../hooks/useLanguage';
import SettingsPanel from './SettingsPanel';
import './SettingsButton.css';

/**
 * 設定ボタンコンポーネント
 */
const SettingsButton: React.FC = () => {
  const lang = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // パネルの開閉をトグル
  const handleClick = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  // パネルを閉じる
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <div className="settings-button-container">
      <button
        ref={buttonRef}
        className={`settings-button ${isOpen ? 'settings-button--active' : ''}`}
        onClick={handleClick}
        aria-label={lang === 'ja' ? '設定' : 'Settings'}
        aria-expanded={isOpen}
        aria-haspopup="dialog"
      >
        {/* 歯車アイコン */}
        <svg
          className="settings-button__icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      </button>

      <SettingsPanel
        isOpen={isOpen}
        onClose={handleClose}
        triggerRef={buttonRef}
      />
    </div>
  );
};

export default SettingsButton;
